(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tesimonial-flickty-slider"] && !Shopify.designMode) return;
  try {
    
  if (typeof Flickity === 'undefined') {
    const flickityCSS = document.createElement("link");
    flickityCSS.rel = "stylesheet";
    flickityCSS.href = "https://unpkg.com/flickity@2/dist/flickity.min.css";
    document.head.appendChild(flickityCSS);

    const flickityJS = document.createElement("script");
    flickityJS.src = "https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js";
    document.body.appendChild(flickityJS);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(sec) {
      if (sec.dataset.igCarouselReady) return;
      var track = sec.querySelector('.ig-testimonial-track--carousel');
      var prev = sec.querySelector('.ig-testimonial-nav .prev');
      var next = sec.querySelector('.ig-testimonial-nav .next');
      if (!track || !prev || !next) return;
      sec.dataset.igCarouselReady = '1';
      function step() {
        var card = track.querySelector('.ig-testimonial-card');
        if (!card) return track.clientWidth;
        return card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      }
      function sync() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }
      prev.addEventListener('click', function() { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function() { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    function boot() { document.querySelectorAll('[data-ig-testimonial-carousel]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
